import { computed } from '@vue/reactivity'
import { User, UserManager, WebStorageStateStore } from 'oidc-client-ts'
import { defineStore } from 'pinia'
import { useRouter } from 'vue-router'
import { ref } from 'vue'
export const authStore = defineStore(
  'auth',
  () => {
    const user = ref()
    const route = useRouter();
    const tokenValid = computed(() => {
      if (user.value !== undefined) {
        const u = (user.value as User);
        return u.expires_at !== undefined && (u.expires_at * 1000) > Date.now();
      }
      return false;
    });

    const manager = new UserManager({
      authority: process.env.VUE_APP_AUTHORITY,
      client_id: process.env.VUE_APP_CLIENT_ID,
      redirect_uri: `${process.env.VUE_APP_BASE_URL}/callback`,
      scope: "email profile openid offline_access",
      automaticSilentRenew: false,
      monitorSession: true,
      revokeTokensOnSignout: true,
      post_logout_redirect_uri: `${process.env.VUE_APP_BASE_URL}`,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      prompt: "select_account"
    });
    manager.events.addUserSignedIn(() => {
      try {
        console.log("User signed in callback");
      } catch (err) {
        console.error(err);
      }
    });
    manager.events.addAccessTokenExpired(() => {
      try {
        console.log("Access Token Expired Callback");
        signinSilent();
      } catch (err) {
        console.error(err);
      }
    });
    manager.events.addAccessTokenExpiring(() => {
      try {
        console.log("Access Token Expiring");
        signinSilent();
      } catch (err) {
        console.error(err);
      }
    });
    manager.events.addUserLoaded(() => {
      console.log("user loaded")
    })
    const login = async () => {
      try {
        console.log("logged in")
        await manager.signinRedirect();
      } catch (err) {
        console.error(err);
      }
    };
    const logout = async () => {
      try {
        console.log("logged out")
        localStorage.clear();
        // user.value = undefined;
        await manager.revokeTokens();
        route.push("/");
        await manager.signoutRedirect({
          post_logout_redirect_uri: `${process.env.VUE_APP_BASE_URL}`,
          id_token_hint: user.value?.id_token
        });
        user.value = undefined;
        route.push("/");
      } catch (err) {
        console.error(err);
      }
    };
    const signinSilent = async () => {
      try {
        const c = await manager.signinSilent();
        user.value = c;
        manager.storeUser(c);
        const c2 = await manager.signinSilentCallback();
        console.log(c);
        user.value = c2;
        manager.storeUser(c2!);
      } catch (err) {
        console.error(err);
      }
    };
    const loginCallback = async () => {
      try {
        console.log("callback");
        const c = await manager.signinRedirectCallback();
        manager.storeUser(c);
        user.value = c;
      } catch (err) {
        console.error(err);
      }
    };
    return { user, tokenValid, login, loginCallback, logout }
  },
  {
    persist: true,
  },

)
